import {useState, useRef, useEffect} from 'react'

const useScrollToMoreButton = () => {
    const [scrollToMore, setScrollToMore] = useState(false)

    const moreButtonRef = useRef(null)

    useEffect(() => {
        if (scrollToMore && moreButtonRef.current) {
            moreButtonRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        }
    }, [scrollToMore])

    return {setScrollToMore, moreButtonRef}
}

export default useScrollToMoreButton
